/**
 * URL axis — how the user arrived, derived from the `started_flow` param:
 * - `resolved`: already in the flow (`=true`) — render the current step in place.
 * - `deeplink`: an external caller routed directly to a step (present, not `true`) — honor it.
 * - `default`: any other entry (absent) — the draft decides the step.
 */
type EntryState = 'resolved' | 'deeplink' | 'default';

export function classifyEntry(startedFlowParam: string | undefined): EntryState {
	if (startedFlowParam === 'true') return 'resolved';
	if (startedFlowParam !== undefined) return 'deeplink';
	return 'default';
}
